import { render } from "./NegociosPlanes.vue?vue&type=template&id=67103dfd&scoped=true"
import script from "./NegociosPlanes.vue?vue&type=script&lang=js"
export * from "./NegociosPlanes.vue?vue&type=script&lang=js"

import "./NegociosPlanes.vue?vue&type=style&index=0&id=67103dfd&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67103dfd"]])

export default __exports__